export default __webpack_public_path__ + "static/media/systs.96f958ca.png";